import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appAutocompleteContent]',
})
export class AutocompleteContentDirective {
  tpl = inject<TemplateRef<unknown>>(TemplateRef);
}
